
import { Component, computed, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { UserService } from '../plateformebeneficiaire/core';
import { ToastModule } from 'primeng/toast';
import { APP_ROUTES_MENU } from '../app.routes';
import { environment } from '../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss']
})
export class AppTopBarComponent {
  deferredPrompt: any = null;

  #userService = inject(UserService);

  #userInfoQuery = this.#userService.getUserInfos();
  userInfos = computed(() => this.#userInfoQuery.data());
  isLoading = computed(() => this.#userInfoQuery.isLoading());

  menu: MenuItem[] = [];

  ROUTES = APP_ROUTES_MENU;

  @ViewChild('searchinput') searchInput!: ElementRef;

  @ViewChild('menubutton') menuButton!: ElementRef;

  searchActive: boolean = false;
  displaycurrentbreakpoint: boolean = !environment.hideTailwindBreakpoints;

  constructor(public layoutService: LayoutService) {
  }

  ngOnInit() {
  }

  logout() {
    this.#userService.logout();
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  activateSearch() {
    this.searchActive = true;
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 100);
  }

  deactivateSearch() {
    this.searchActive = false;
  }

  removeTab(event: MouseEvent, item: MenuItem, index: number) {
    this.layoutService.onTabClose(item, index);
    event.preventDefault();
  }

  get layoutTheme(): string {
    return this.layoutService.config().layoutTheme;
  }

  get colorScheme(): string {
    return this.layoutService.config().colorScheme;
  }

  get logo(): string {
    const path = 'assets/plateformebeneficiaire/images/logo.png';
    // const logo = (this.layoutTheme === 'primaryColor'  && !(this.layoutService.config().theme  == "yellow")) ? 'light.png' : (this.colorScheme === 'light' ? 'dark.png' : 'light.png');
    return path;
  }

  get tabs(): MenuItem[] {
    return this.layoutService.tabs;
  }

  get isMobileLayout(): boolean {
    return this.layoutService.isMobile();
  }

  getUserInitials(): string {
    const user = this.userInfos();
    if (!user) return '?';

    const initials = `${user.nom?.charAt(0) || ''}${user.prenom?.charAt(0) || ''}`.toUpperCase();
    return initials || '?';
  }
}
